/**
 * SEO component that queries for data with
 *  Gatsby's useStaticQuery React hook
 *
 * See: https://www.gatsbyjs.com/docs/use-static-query/
 */

import React from "react"
import PropTypes from "prop-types"
import { Helmet } from "react-helmet"
import { useLocation } from "@reach/router";
import { useStaticQuery, graphql } from "gatsby"

function SEO({ image_url, description, lang, meta, title, location }) {
  const { site } = useStaticQuery(
    graphql`
      query {
        site {
          siteMetadata {
            title
            description
            author
          }
        }
      }
    `
  )

  const metaDescription = description || site.siteMetadata.description
  const defaultTitle = site.siteMetadata?.title
  var currentURL = '';
  if (location !== undefined && location.pathname) {
    currentURL = process.env.GATSBY_SITE_URL + location.pathname;
  }

  const metaImg = image_url?image_url:`https://ggfx-dachare.s3.eu-west-2.amazonaws.com/i.prod/dacha_logo_a4c52644e6.png`

  if (!currentURL.endsWith('/'))
    currentURL = currentURL + '/'

  /* code for robots tag function */
    var {pathname} = useLocation();
    var curPath = pathname;
    if (!pathname.endsWith('/')){
      curPath = pathname + '/';
    }
   // console.log("pathname",pathname,curPath)
   
    const robotsIndexList  = [
      "/off-plan-properties/",
      "/sell-your-property/"
    ];
    const robotsNoIndexList = [
      "/about-dacha/careers/property-consultant/",
      "/about-dacha/careers/sales-executive/"
];

    
    const robotsUrl = (curPath) =>{
     let robotsTxt = {};
      if (robotsNoIndexList.includes(curPath)) {
        robotsTxt = {
          name: "robots",
          content: "noindex, nofollow",
        };
      } else if (robotsIndexList.includes(curPath)) {
        robotsTxt = {
          name: "robots",
          content: "index, follow",
        };
      }
      return robotsTxt;
  }
   
    /* code for robots tag function */
   

  return (
    <Helmet
      htmlAttributes={{
        lang,
      }}
      title={title}
      titleTemplate={defaultTitle ? `%s | ${defaultTitle}` : null}
      link={[
        {
          href: currentURL,
          rel: "canonical"
        }
      ]} 
      meta={[
        {
          name: `description`,
          content: metaDescription,
        },
        robotsUrl(curPath) , 
        {
          property: `og:title`,
          content: title,
        },
        {
          property: `og:description`,
          content: metaDescription,
        },
        {
          property: `og:url`,
          content: currentURL,
        },
        {
          property: `og:type`,
          content: `website`,
        },
        {
          name: `twitter:card`,
          content: `summary`,
        },
        {
          name: `twitter:creator`,
          content: site.siteMetadata?.author || ``,
        },
        {
          name: `twitter:title`,
          content: title,
        },
        {
          name: `twitter:description`,
          content: metaDescription,
        },
        {
          name: `facebook-domain-verification`,
          content: 'vdkffx5ct5qyun4d508t0d75w06p2I',
        },
        {
          name: `twitter:image`,
          content: metaImg,
        },
        {
          property: `og:image`,
          content: metaImg,
        },
      ].concat(meta).filter(Boolean)}
    >

    </Helmet>
  )
}

SEO.defaultProps = {
  lang: `en`,
  meta: [],
  description: ``,
}

SEO.propTypes = {
  description: PropTypes.string,
  lang: PropTypes.string,
  meta: PropTypes.arrayOf(PropTypes.object),
  title: PropTypes.string.isRequired,
}

export default SEO
